// extracted by mini-css-extract-plugin
export default {"countrySection":"Country_countrySection__HGWT2"};